module.exports = __webpack_public_path__ + "img/V-63-ER-1000-B.5e27742c.png";